/* eslint-disable prettier/prettier */
import { Textarea } from 'app/components/ui/textarea';
import React, { useState } from 'react';

import { useFormContext } from 'react-hook-form';

function Excerpt() {
  const form = useFormContext();

  return (
    <div className="">
      <h2 className="text-sm mb-2 font-semibold">Excerpt</h2>
      <Textarea
        placeholder="Add Excerpt"
        className="border border-black h-[40px] rounded px-2 w-full bg-white  dark:bg-transparent"
        {...form.register('excerpt')}
      />
    </div>
  );
}
export default Excerpt;
